// extracted by mini-css-extract-plugin
export default {"wrapper":"SchoolElements_wrapper__KA0h-"};